import { Model } from 'backbone';
import Storage from '../../utils/Storage';
import _ from 'lodash';

/**
 * The Onboarding Model is used to store data during the Onboarding process.
 * This will contain data collected before the user is authenticated.
 * LocalStorage is used to persist data on refresh of page or returning to the
 * page after exiting the onboarding process when partially completed.
 *
 * @class OnboardingModel
 * @extends {Model}
 */
class OnboardingModel extends Model {

	initialize() {
		this.on('change', this.changeStorage);

		this.set(this.store);
	}

	changeStorage(model) {
		const parsed_model = model.toJSON();

		if (_.isEmpty(parsed_model)){
			return
		}

		this.store = parsed_model;
	}

	get url() {
		return this.methodUrl;
	}

	set url( url ) {
		if ( !_.isString( url ) ) {
			throw new Error( 'URL field should be a string' );
		}

		this.methodUrl = url;

		return this.methodUrl;
	}

	get store() {
		return Storage.get('onboarding');
	}

	set store(onboarding_data) {
		const onboarding_store = Object.assign({}, Storage.get('onboarding'), onboarding_data);
		Storage.set('onboarding', onboarding_store);
	}

	clearModelAndStore() {
		Storage.remove('onboarding');
		this.clear();
	}

	/**
	 * TODO (Dan): remove this method, use User model
	 * @deprecated
	 */
	async checkExistingUserAccountCredentials(credentials) {
		this.url = 'nrlaccount/check_credentials';
		const { success, result, errors } = await this.save(
			null,
			{
				data: credentials
			}
		);

		if(!success) {
			this.trigger('user:check_credentials:fail', errors);
			return;
		}

		this.saveUser(result);
		this.set({
			user_login_type: 'recovery_token'
		});

		this.trigger('user:check_credentials:success');
	}

	/**
	 * TODO (Dan): move this to User model
	 * @deprecated
	 */
	saveUser(result) {
		this.set({
			user: result.user,
			recovery_token: result.recovery_token
		});
	}

	async linkUserAccounts(identity_token) {
		this.url = 'nrlaccount/link_account';
		const type = this.get('user_login_type');
		const recovery_token = this.get('recovery_token');

		const data = {
			type,
			identity_token,
			recovery_token
		};

		const { success, result, errors } = await this.save(null, { data });

		if(!success) {
			this.trigger('user:link:fail', errors);
			return;
		}

		this.trigger('user:link:success', result);
	}

	/**
	 * Overwrite parse method and control model manually
	 *
	 * @returns {false}
	 * @memberof OnboardingModel
	 */
	parse() {
		return false;
	}
}

export default OnboardingModel;